
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import router from "@/router/index";
import sha256 from "js-sha256";
import i18n from "@/config/i18n";
@Component
export default class PiSafePassword extends Vue {
  private modalSafePassword = false;
  private returnData = true; // 是否直接返回密码，不做其它操作
  private ruleInline: objAny = {
    password: [
      {
        required: true,
        message: i18n.t("safePassword.passwordPl"),
        trigger: "blur"
      }
    ]
  };
  private passwordType = "text";
  private formObj: objAny = {};
  private formInline: objAny = {
    password: ""
  };
  private formData: object = {};
  public open(data?: objAny) {
    if (data) {
      this.formData = data;
    }
    this.modalSafePassword = true;
  }
  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        if (!this.returnData) {
          this.subData();
        } else {
          this.callBack();
        }
      }
    });
  }
  public callBack() {
    this.$emit("success", sha256.sha256(this.formInline.password));
  }
  public close() {
    this.modalSafePassword = false;
  }
  async subData(): Promise<void> {
    this.callBack();
    this.close();
  }
  public goSet() {
    router.push("/operators/oper-info");
    this.close();
  }
  mounted() {
    this.formObj = this.$refs.formInline;
  }
}
